const defaultRotation = 0;

const driverIcon = (angle: number) => {
  const svg = `<svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style="transform: rotate(${defaultRotation + angle}deg)">
        <g clipPath="url(#clip0_107_2)">
            <path
                d="M19.3206 15.6601C22.082 10.8772 20.4432 4.76127 15.6603 1.99985C10.8774 -0.761573 4.76147 0.877178 2.00005 5.6601C-0.761378 10.443 0.877373 16.5589 5.6603 19.3204C10.4432 22.0818 16.5591 20.443 19.3206 15.6601Z"
                fill="#60FA67"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.607 10.5858C14.6139 10.7544 14.5589 10.9058 14.4418 11.0399L14.085 11.4273C13.9645 11.5583 13.8166 11.6273 13.6413 11.6345C13.4626 11.6419 13.3112 11.5851 13.187 11.4643L11.6683 10.0707L11.8123 13.5638C11.8193 13.7357 11.763 13.878 11.6434 13.9906C11.5238 14.1032 11.3764 14.1631 11.2011 14.1704L10.566 14.1966C10.3907 14.2038 10.2388 14.1562 10.1104 14.0538C9.98184 13.9515 9.91406 13.8142 9.90699 13.6422L9.76306 10.1492L8.36422 11.6631C8.25035 11.7937 8.10402 11.8627 7.92546 11.8701C7.74685 11.8774 7.59537 11.8207 7.47114 11.6999L7.08368 11.3431C6.95278 11.2227 6.88386 11.0763 6.8767 10.9044C6.86951 10.729 6.92613 10.576 7.04666 10.4451L10.1436 7.08187C10.2543 6.9548 10.4006 6.8874 10.5826 6.87995C10.7612 6.87261 10.9142 6.92757 11.0417 7.04486L14.4048 10.1419C14.5325 10.2657 14.5999 10.4137 14.607 10.5858Z"
                fill="#2A2F39"
            />
        </g>
    </svg>`;

  return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
};

export default driverIcon;
